// files signature https://gist.github.com/overtrue/0a2aec7c2fbe9621a869
import { getExtension } from 'shared/lib/getExtension'

const getFileSignature = (signature: string, bytes?: Uint8Array) => {
  switch (signature) {
    case '42454749':
      return 'text/vcard'
    case '89504e47':
      return 'image/png'
    case '25504446':
      return 'application/pdf'
    case 'd0cf11e0':
      return 'application/msword'
    case 'ffd8ffe0':
      return 'image/jpeg'
    case 'fffb9064':
      return 'audio/mpeg'
    case '00020':
      return 'video/mp4'
    default:
      if (bytes && bytes.length >= 12) {
        const ftypBytes = bytes.subarray(4, 8)
        const ftypHex = Array.from(ftypBytes)
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('')

        if (ftypHex === '66747970') {
          // Bytes 8-11 contain the major brand identifier
          const brandBytes = bytes.subarray(8, 12)
          const brand = String.fromCharCode(...brandBytes)

          if (brand === 'heic') {
            return 'image/heic'
          }

          if (brand === 'heif') {
            return 'image/heif'
          }

          return 'unsupported'
        }
      }
      return 'unsupported'
  }
}

const isMarkdownFile = (file: File) => {
  const extension = getExtension(file.name)
  return ['markdn', 'markdown', 'md', 'mdown'].includes(extension)
}

const isHeicFile = (file: File) => {
  const extension = getExtension(file.name)
  return ['heic'].includes(extension)
}

const isHeifFile = (file: File) => {
  const extension = getExtension(file.name)
  return ['heif'].includes(extension)
}

export const getContentType = (data: File): Promise<string> => {
  return new Promise((resolve) => {
    if (data.type && data.type !== '' && data.type !== 'application/octet-stream') {
      return resolve(data.type)
    }

    if (isHeicFile(data)) {
      return resolve('image/heic')
    }

    if (isHeifFile(data)) {
      return resolve('image/heif')
    }

    if (isMarkdownFile(data)) {
      return resolve('text/markdown')
    }

    const fileReader = new FileReader()

    fileReader.onloadend = (e) => {
      const target = e.target
      const result = target?.result

      if (result instanceof ArrayBuffer) {
        const arr = new Uint8Array(result).subarray(0, 12)
        let header = ''
        for (let i = 0; i < 4; i++) {
          header += arr[i].toString(16).padStart(2, '0')
        }

        const type = getFileSignature(header, arr)

        if (type !== 'unsupported') {
          return resolve(type)
        }

        if (isHeicFile(data)) {
          return resolve('image/heic')
        }

        if (isHeifFile(data)) {
          return resolve('image/heif')
        }

        return resolve('unsupported')
      }

      if (isHeicFile(data)) {
        return resolve('image/heic')
      }

      if (isHeifFile(data)) {
        return resolve('image/heif')
      }

      resolve('')
    }

    fileReader.readAsArrayBuffer(data)
  })
}
